import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import StatusBadgeCst from "@components/StatusBadgeCst";
import { GroupListItem } from "../../../hooks/useGroupsList";

interface GroupRowProps {
  group: GroupListItem;
}

const GroupRow: React.FC<GroupRowProps> = ({ group }) => {
  const theme = useTheme();
  const { t } = useTranslation("users-and-groups");
  const typeLabel = String(
    t(
      group.type === "DYNAMIC"
        ? "options.group_type.dynamic"
        : "options.group_type.static",
      { ns: "input" },
    ),
  );
  const isActive = (group.status || "").toLowerCase() === "active";

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 2,
        minWidth: 0,
        width: "100%",
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", minWidth: 0 }}>
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: 700,
            color: theme.palette.text.primary,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {group.name || `Gruppo ${group.id}`}
        </Typography>
        <Typography
          sx={{
            fontSize: "12px",
            color: theme.palette.text.primary,
            lineHeight: 1.4,
          }}
        >
          {`ID: ${group.id} | ${typeLabel}`}
        </Typography>
      </Box>

      {isActive && (
        <StatusBadgeCst
          label={String(t("row.active", { ns: "users-and-groups" }))}
          variant="active"
        />
      )}
    </Box>
  );
};

export default GroupRow;
